import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';


function Header({setAuthToken, appUserName, setAppUserName, notificationsCount}) {
  notificationsCount = Number.isFinite(notificationsCount) && notificationsCount > 0 ? notificationsCount : 0;

  function UserLogout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('username');
    setAuthToken(null);
    setAppUserName(null);
  }

  function NotificationRedDot({notificationsCount}) {
    return notificationsCount ? (
      <>
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="white" className="mx-1 mt-1 bi bi-bell" viewBox="0 0 16 16">
          <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2"/>
          <path d="M8 1.918a1 1 0 0 0-.9.55 5 5 0 0 0-2.7 4.58c0 1.48-.5 2.52-1.13 3.2-.26.28-.53.51-.75.68-.11.08-.2.15-.27.2l-.08.05A.5.5 0 0 0 2.5 12h11a.5.5 0 0 0 .23-.93l-.08-.05a4 4 0 0 1-.27-.2 4.7 4.7 0 0 1-.75-.68c-.63-.68-1.13-1.72-1.13-3.2a5 5 0 0 0-2.7-4.58 1 1 0 0 0-.9-.55M14.22 12c.25 0 .48-.11.64-.29a1.03 1.03 0 0 0 .14-1.2l-.05-.07-.15-.1a4.7 4.7 0 0 1-.25-.19 3.7 3.7 0 0 1-.6-.55c-.47-.52-.95-1.35-.95-2.87a6 6 0 0 0-3.25-5.43A2 2 0 0 0 8 0a2 2 0 0 0-1.75 1.05A6 6 0 0 0 3 6.73c0 1.52-.48 2.35-.95 2.87-.2.22-.42.4-.6.55a4.7 4.7 0 0 1-.25.19l-.15.1A1.03 1.03 0 0 0 1.4 12c.16.18.39.29.64.29z"/>
        </svg>
        <svg height="40" width="20" xmlns="http://www.w3.org/2000/svg">
          <circle r="10" cx="10" cy="10" fill="rgb(255, 59, 59)" />
          <text x="50%" y="25%" textAnchor="middle" fill="rgb(255, 255, 255)" dy=".3em">{notificationsCount}</text>
        </svg>
      </>
    ) : (
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="white" className="mx-1 mt-1 bi bi-bell" viewBox="0 0 16 16">
        <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2"/>
        <path d="M8 1.918a1 1 0 0 0-.9.55 5 5 0 0 0-2.7 4.58c0 1.48-.5 2.52-1.13 3.2-.26.28-.53.51-.75.68-.11.08-.2.15-.27.2l-.08.05A.5.5 0 0 0 2.5 12h11a.5.5 0 0 0 .23-.93l-.08-.05a4 4 0 0 1-.27-.2 4.7 4.7 0 0 1-.75-.68c-.63-.68-1.13-1.72-1.13-3.2a5 5 0 0 0-2.7-4.58 1 1 0 0 0-.9-.55M14.22 12c.25 0 .48-.11.64-.29a1.03 1.03 0 0 0 .14-1.2l-.05-.07-.15-.1a4.7 4.7 0 0 1-.25-.19 3.7 3.7 0 0 1-.6-.55c-.47-.52-.95-1.35-.95-2.87a6 6 0 0 0-3.25-5.43A2 2 0 0 0 8 0a2 2 0 0 0-1.75 1.05A6 6 0 0 0 3 6.73c0 1.52-.48 2.35-.95 2.87-.2.22-.42.4-.6.55a4.7 4.7 0 0 1-.25.19l-.15.1A1.03 1.03 0 0 0 1.4 12c.16.18.39.29.64.29z"/>
      </svg>
    );
  }

  return(
    <nav className="navbar navbar-dark bg-opacity-75 bg-gradient fixed-top fsvok2" >
      <div className="container-fluid px-5">
        <a className="navbar-brand lk-navbar-link" href="/">ФСВОК | кабинет ведущего специалиста</a>
        <div className="">
          <Link className="lk-navbar-link mx-3" to={`notifications`}>
            <NotificationRedDot
              notificationsCount={notificationsCount}
            />
          </Link>
          <span className="navbar-text ml-5"> Пользователь: {appUserName} <button className="mx-1 lk-button lk-nav-button" onClick={UserLogout}>Выход</button></span>
        </div>
      </div>
    </nav>
  );
}

Header.propTypes = {
  setAuthToken: PropTypes.func.isRequired,
  notificationsCount: PropTypes.number
};

export default Header